import { animate, stagger } from 'animejs';

/**
 * Animate
 * Plays on load. This bar sits in the first screen, so a scroll-scrubbed
 * entrance would finish as the page opens.
 */
(() => {
  const items = document.querySelectorAll('.animate .hero-usp .hero-usp__item');
  if (!items.length) return;

  items.forEach((item) => {
    item.style.opacity = '0';
  });

  animate(items, {
    y: ['18px', 0],
    opacity: [0, 1],
    duration: 850,
    delay: stagger(140, { start: 280 }),
    ease: 'outCubic',
  });
})();
